import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { RDReadyLayout } from './components/RDReadyLayout';
import { RDReadyHome } from './components/pages/site/RDReadyHome';
import { RDReadyAbout } from './components/pages/site/RDReadyAbout';
import { RDReadyContact } from './components/pages/site/RDReadyContact';
import { CNSCPrep } from './components/pages/site/CNSCPrep';
import { RDExam } from './components/pages/site/RDExam';
import { CNSCExam } from './components/pages/site/CNSCExam';
import { Study } from './components/pages/site/Study';
import { Checkout } from './components/pages/site/Checkout';
import { Login, Signup, ForgotPassword } from './components/pages/site/Auth';
import { Account } from './components/pages/site/Account';
import { Privacy } from './components/pages/site/Privacy';
import { Terms } from './components/pages/site/Terms';
export function App() {
  useEffect(() => {
    document.title = 'RD Ready | CNSC Exam Prep';
  }, []);
  return <AuthProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route element={<RDReadyLayout data-id="element-4" />} data-id="element-3">
            <Route path="/" element={<RDReadyHome data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<RDReadyAbout data-id="element-8" />} data-id="element-7" />
            <Route path="/contact" element={<RDReadyContact data-id="element-10" />} data-id="element-9" />
            <Route path="/rd-exam" element={<RDExam data-id="element-12" />} data-id="element-11" />
            <Route path="/cnsc-exam" element={<CNSCExam data-id="element-14" />} data-id="element-13" />
            <Route path="/cnsc-prep" element={<CNSCPrep data-id="element-16" />} data-id="element-15" />
            <Route path="/checkout" element={<Checkout data-id="element-18" />} data-id="element-17" />
            <Route path="/study" element={<Study data-id="element-20" />} data-id="element-19" />
            <Route path="/login" element={<Login data-id="element-22" />} data-id="element-21" />
            <Route path="/signup" element={<Signup data-id="element-24" />} data-id="element-23" />
            <Route path="/forgot-password" element={<ForgotPassword data-id="element-26" />} data-id="element-25" />
            <Route path="/account" element={<Account data-id="element-28" />} data-id="element-27" />
            <Route path="/privacy" element={<Privacy data-id="element-30" />} data-id="element-29" />
            <Route path="/terms" element={<Terms data-id="element-32" />} data-id="element-31" />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>;
}